import { createContext, useContext } from 'react';

export const GlobalContext = createContext();
export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error(
      'GlobalContext compound components cannot be rendered outside the GlobalContext component',
    );
  }
  return context;
};
